import { render, staticRenderFns } from "./QulityTestInput.vue?vue&type=template&id=0ddf913c"
import script from "./QulityTestInput.vue?vue&type=script&lang=js"
export * from "./QulityTestInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports